import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  id: string;
  checked: boolean;
  onChange: (_value: boolean) => void;
  label: ReactNode;
  className?: string;
};

export const CheckBox = ({ id, checked, onChange, label, className }: Props) => {
  return (
    <div
      className={twMerge(
        'flex items-center p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer',
        className,
      )}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
        onChange={e => onChange(e.currentTarget.checked)}
      />
      <label
        htmlFor={id}
        className="w-full ml-2 text-sm font-medium text-gray-900 rounded dark:text-gray-300 cursor-pointer"
      >
        {label}
      </label>
    </div>
  );
};
